import React from 'react';
import { useNavigate, Link } from '@tanstack/react-router';
import { ColumnDef } from '@tanstack/react-table';
import { getGetRolesQueryOptions } from '@area-restrita/api-client/endpoints/roles/roles.gen';
import { RoleWithIdDto } from '@area-restrita/api-client/model/roleWithIdDto';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import DataGrid from '@/components/DataGrid';
import { Button } from '@/components/ui/button';
import { useQueryTable } from '@/hooks/useQueryTable';

const columns: ColumnDef<RoleWithIdDto>[] = [
  { id: 'name', accessorKey: 'name', header: 'Nome' },
  { id: 'description', accessorKey: 'description', header: 'Descrição' },
];

const Roles: React.FC = () => {
  const navigate = useNavigate();
  const {
    table,
    query: { isLoading },
  } = useQueryTable({
    columns,
    getQueryOptions: getGetRolesQueryOptions,
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>Funções</CardTitle>
        <CardDescription>
          Gerencie funções e permissões de usuários.
        </CardDescription>
      </CardHeader>

      <CardContent className="p-0">
        <DataGrid
          table={table}
          isLoading={isLoading}
          actions={
            <Link to="/settings/roles/new">
              <Button size="sm">Criar Função</Button>
            </Link>
          }
          onRowClick={(role) =>
            navigate({
              to: '/settings/roles/$roleId',
              params: { roleId: role.id },
            })
          }
        />
      </CardContent>
    </Card>
  );
};

export default Roles;
